document.addEventListener('DOMContentLoaded', function () {
    console.log('✅ Zepto.js is loaded.');
  
    //////////////////////////////////////////////////////////////////////////////////////////////////
    // FONT FAMILY HANDLING BASED ON SELECTED FONT
    //////////////////////////////////////////////////////////////////////////////////////////////////
  
    let fontChecks = 0;
    const waitForFontInput = setInterval(() => {
      const fontInput = document.querySelector('.pplr-font-select input.pplr_font');
  
      if (fontInput) {
        clearInterval(waitForFontInput);
  
        const currentFontFile = fontInput.getAttribute('data-value');
        const currentFontName = fontInput.getAttribute('value');
        console.log('[Zepto Font Init] Selected font:', currentFontName, '| File:', currentFontFile);
  
        const initialSpan = document.querySelector(
          `.pplr-selecter-options span.pplr-selecter-item[data-value="${currentFontFile}"]`
        );
        if (initialSpan) {
          const initialFontFamily = initialSpan.style.fontFamily;
          console.log('[Font Init Match] Span text:', initialSpan.innerText);
          console.log('[Font Init Match] style.fontFamily:', initialFontFamily);
  
          document.querySelectorAll('input.pplr_text').forEach((input) => {
            input.style.fontFamily = initialFontFamily;
          });
        }
  
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
              const updatedFontFile = fontInput.getAttribute('data-value');
              const updatedFontName = fontInput.getAttribute('value');
              console.log('[Zepto Font Changed] New font:', updatedFontName, '| File:', updatedFontFile);
  
              const matchingSpan = document.querySelector(
                `.pplr-selecter-options span.pplr-selecter-item[data-value="${updatedFontFile}"]`
              );
  
              if (matchingSpan) {
                const newFontFamily = matchingSpan.style.fontFamily;
                console.log('[Font Match] Span text:', matchingSpan.innerText);
                console.log('[Font Match] style.fontFamily:', newFontFamily);
  
                document.querySelectorAll('input.pplr_text').forEach((input) => {
                  input.style.fontFamily = newFontFamily;
                });
              } else {
                console.warn('[Font Match] No span found for:', updatedFontFile);
              }
            }
          }
        });
  
        observer.observe(fontInput, {
          attributes: true,
          attributeFilter: ['data-value']
        });
      }
  
      // Stop polling after 20 tries (6 seconds)
      if (++fontChecks > 20) clearInterval(waitForFontInput);
    }, 300);
  
    //////////////////////////////////////////////////////////////////////////////////////////////////
    // CREATES HIDDEN FIELD SERVICE VALUE
    //////////////////////////////////////////////////////////////////////////////////////////////////

    // --- CSS class that hides field can be found in Zepto app > settings > custom CSS ---
  
    let serviceChecks = 0;
    const waitForZeptoTextarea = setInterval(() => {
      const container = document.querySelector('.pplr-_hidden-service');
      const textarea = container?.querySelector('textarea');
  
      if (textarea && textarea.getAttribute('placeholder')) {
        const placeholder = textarea.getAttribute('placeholder');
        textarea.value = placeholder;
        textarea.removeAttribute('placeholder');
  
        console.log('[Zepto Placeholder] Applied placeholder as value:', placeholder);
        clearInterval(waitForZeptoTextarea);
      }
  
      if (++serviceChecks > 20) clearInterval(waitForZeptoTextarea);
    }, 300);
  
    //////////////////////////////////////////////////////////////////////////////////////////////////
    // SWAPS FONT SELECTION ABOVE INPUT FIELD
    //////////////////////////////////////////////////////////////////////////////////////////////////
  
    let swapChecks = 0;
    const waitForFontAndInputSwap = setInterval(() => {
      const allLine1Divs = document.querySelectorAll('.pplr-personalization-line-1');
  
      let fontSelectDiv = null;
      let textInputDiv = null;
  
      allLine1Divs.forEach(div => {
        if (div.classList.contains('pplr-font-select')) {
          fontSelectDiv = div;
        } else {
          textInputDiv = div;
        }
      });
  
      if (fontSelectDiv && textInputDiv && textInputDiv.parentNode) {
        textInputDiv.parentNode.insertBefore(fontSelectDiv, textInputDiv);
        console.log('[Zepto Swap] Font select moved above text input.');
        clearInterval(waitForFontAndInputSwap);
      }
  
      if (++swapChecks > 20) clearInterval(waitForFontAndInputSwap);
    }, 300);
});
  
//////////////////////////////////////////////////////////////////////////////////////////////////
// INJECT SKU INTO HIDDEN TEXTAREA FIELD
//////////////////////////////////////////////////////////////////////////////////////////////////

// --- CSS class that hides field can be found in Zepto app > settings > custom CSS ---

let skuChecks = 0;
const waitForHiddenSKUField = setInterval(() => {
  const sku = window.ShopifyAnalytics?.meta?.product?.variants?.[0]?.sku;
  const container = document.querySelector('.pplr-_hidden-sku');
  const textarea = container?.querySelector('textarea');

  if (sku && textarea) {
    textarea.value = sku;
    textarea.removeAttribute('placeholder');
    console.log('[Zepto SKU Inject] SKU injected into hidden field:', sku);
    clearInterval(waitForHiddenSKUField);
  }

  // Fail-safe: stop checking after 6 seconds
  if (++skuChecks > 20) clearInterval(waitForHiddenSKUField);
}, 300);
